/* ==========================================================================
   dewy — athlete-rotator.js
   Crossfades the athlete slides in .athrot.

   Replaces the original CSS-keyframe crossfade, which was hardcoded to exactly
   two slides. This handles any number, so the section's blocks can be edited
   freely in the theme editor.

   Reads per-instance timing from the container:
     data-hold  — ms each slide stays fully visible (default 7000)
     data-fade  — ms of crossfade (default 1200)

   With one slide it shows it and stops. Under prefers-reduced-motion it pins
   the first slide and never cycles.
   ========================================================================== */
(function () {
  'use strict';

  function init(rot) {
    var slides = Array.prototype.slice.call(rot.querySelectorAll('.athfull'));
    if (!slides.length) return;

    // Re-initialising the same element (theme editor reload) must not leave the
    // previous timer and observer running alongside the new ones.
    if (rot._dewyTeardown) rot._dewyTeardown();

    var hold = parseInt(rot.dataset.hold, 10) || 7000;
    var fade = parseInt(rot.dataset.fade, 10) || 1200;
    rot.style.setProperty('--ath-fade', fade + 'ms');

    // Taking over from the CSS :not([data-rotator-ready]) fallback.
    slides[0].classList.add('is-active');
    rot.setAttribute('data-rotator-ready', '');

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || slides.length < 2) return;

    var i = 0;
    var timer = null;

    function advance() {
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }

    function start() { if (!timer) timer = setInterval(advance, hold + fade); }
    function stop()  { clearInterval(timer); timer = null; }

    function onVisibility() {
      if (document.hidden) stop(); else start();
    }
    document.addEventListener('visibilitychange', onVisibility);

    var observer = null;
    if ('IntersectionObserver' in window) {
      // Don't burn cycles animating a section nobody is looking at.
      observer = new IntersectionObserver(function (entries) {
        entries[0].isIntersecting ? start() : stop();
      }, { threshold: 0.15 });
      observer.observe(rot);
    } else {
      start();
    }

    rot._dewyTeardown = function () {
      stop();
      document.removeEventListener('visibilitychange', onVisibility);
      if (observer) observer.disconnect();
      slides.forEach(function (s) { s.classList.remove('is-active'); });
      rot._dewyTeardown = null;
    };
  }

  function initAll() {
    document.querySelectorAll('.athrot').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-initialise when the section is edited in the theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.athrot').forEach(init);
  });
})();
